<div class="flex justify-content-end -mb-6 absolute right-0 z-1">
  <app-search-input (search)="filterTypes($event)"></app-search-input>
</div>
<div class="grid">
  <div *ngFor="let type of ['Polygon', 'Point']" class="col-6">
    <p-scrollPanel
      *ngIf="
        groupedDataLayerTypes &&
        groupedDataLayerTypes[type] &&
        dataLayerStore.initialized()
      "
      styleClass="h-25rem">
      <div>
        @for (
          dataLayerType of groupedDataLayerTypes[type];
          track dataLayerType._id
        ) {
          <div
            cdkDrag
            [cdkDragData]="dataLayerType"
            class="pt-1 pb-3 surface-border"
            [ngClass]="{
              'border-bottom-1': !$last,
              'border-bottom-none': $last
            }">
            <app-data-layer-type-entry
              selectionMode="multiple"
              [showControls]="false"
              [dataLayerType]="dataLayerType"></app-data-layer-type-entry>
          </div>
        }
      </div>
    </p-scrollPanel>
  </div>
</div>
